export const CIKIS_SEBEP_LABELS = {
  istifa: "İstifa",
  fesih: "İşveren Feshi",
  emeklilik: "Emeklilik",
  vefat: "Vefat",
  diger: "Diğer",
};
